<ag-shr-modal-window
  #deleteAgentModalRef
  [title]="'Delete Agent'"
  [width]="'400px'"
  [height]="'auto'"
  [saveButtonDisabled]="!formData?.deleteAgentRecord && !formData?.deleteAuthLogin"
  [inProgress]="inProgress$ | async"
  [actionTitle]="'CONFIRM'"
  (onSaveClick)="handleSave($event)"
>
  <dx-form [formData]="formData" labelMode="floating">
    <dxi-item
      dataField="deleteAuthLogin"
      editorType="dxSwitch"
      cssClass="delete-agent-modal__switcher ag-switch-with-label"
      [label]="{ text: 'Delete Auth Login?' }"
      [editorOptions]="{ location: 'right' }"
    ></dxi-item>

    <dxi-item
      dataField="deleteAgentRecord"
      editorType="dxSwitch"
      cssClass="delete-agent-modal__switcher ag-switch-with-label"
      [label]="{ text: 'Delete Agent Account?' }"
      [editorOptions]="{ location: 'right' }"
    ></dxi-item>
  </dx-form>
</ag-shr-modal-window>
